import { render, staticRenderFns } from "./_kingmidas.vue?vue&type=template&id=201d657b&lang=pug&"
import script from "./_kingmidas.vue?vue&type=script&lang=js&"
export * from "./_kingmidas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports